<div class="lang-switcher" [class.open]="open()">
  <button class="lang-switcher__btn" (click)="toggle()" [attr.aria-expanded]="open()">
    <span class="flag">{{ current.flag }}</span>
    <span class="code">{{ current.code.toUpperCase() }}</span>
    <svg width="10" height="10" viewBox="0 0 10 10" [style.transform]="open() ? 'rotate(180deg)' : ''">
      <path d="M1 3l4 4 4-4" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/>
    </svg>
  </button>

  @if (open()) {
    <ul class="lang-switcher__dropdown" role="listbox">
      @for (l of langs; track l.code) {
        <li role="option" [class.active]="l.code === ts.lang()" (click)="select(l.code)">
          <span class="flag">{{ l.flag }}</span>
          <span class="label">{{ l.label }}</span>
          @if (l.code === ts.lang()) {
            <svg class="check" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M2 7l4 4 6-6" stroke="#0066cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          }
        </li>
      }
    </ul>
  }
</div>
